import {
    TOASTR_ADD,
    TOASTR_RESET,
    TOASTR_REMOVE
} from '../constants/ActionTypes';

export function toastrAdd(payload) {
  return {
    type: TOASTR_ADD,
    payload
  };
}

export function toastrRemove(index) {
  return {
    type: TOASTR_REMOVE,
    index
  }
}

export function toastrReset() {
    return {
        type: TOASTR_RESET
    };
}
